export const EVENTS = {
  DEALS: {
    LOAD: 'deals.load',
    LOADING: 'deals.loading',
    LOADED: 'deals.loaded',
    LOAD_ERROR: 'deals.load_error',
    LOAD_DETAIL: 'deals.load_detail',
    LOAD_DISHES: 'deals.load_dishes',
    SHOW_DETAIL: 'deals.show_detail'
  }
};

export const ENDPOINTS = {
  DEALS: {
    LOAD: 'https://api.monrapidoo.com/rapidoo-aggregation/deals?group=ultraxeno',
    DETAIL: (id) => `https://api.monrapidoo.com/rapidoo-aggregation/deals/${id}?group=ultraxeno`
  }
};
